module.exports =  {
    bindings: {},
    controller: quotaTableController,
    templateUrl: 'quota/components/quota-table.html'
}

quotaTableController.$inject = ['quotaDataService', 'quotaModals'];

function quotaTableController(quotaDataService, quotaModals) {
    var vm = {
        service: quotaDataService,
        isLoading: false,
        loadPage: loadPage,
        loadGraph: loadGraph,
        numberWithCommas: numberWithCommas
    };

    function loadPage() {
        vm.service.getQuotas();
    }

    function loadGraph(quota) {
        quotaModals.orderQuota.show(quota.ordnumb);
    }

    function numberWithCommas(x) {
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return parts.join(",");
    }

    return vm;

}